import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  description: {
    defaultMessage:
      'Transfer not possible from selected account. Please choose a different account if possible',
    id: 'FraudPreventionErrorScreen.description',
  },
  title: {
    defaultMessage: 'Payment Failed',
    id: 'FraudPreventionErrorScreen.title',
  },
  close: {
    defaultMessage: 'Close',
    id: 'FraudPreventionErrorScreen.primaryButton.text',
  },
});
